export const MAIN_LAYOUT_RESET = 'MAIN_LAYOUT_RESET';
export const MAIN_LAYOUT_SET_PARAMS = 'MAIN_LAYOUT_SET_PARAMS';
export const MAIN_LAYOUT = 'MAIN_LAYOUT';
export const MAIN_LAYOUT_SUCCESS = 'MAIN_LAYOUT_SUCCESS';
export const MAIN_LAYOUT_FAIL = 'MAIN_LAYOUT_FAIL';
export const MAIN_LAYOUT_CHECK = 'MAIN_LAYOUT_CHECK';
export const MAIN_LAYOUT_NOT_SIGN_IN = 'MAIN_LAYOUT_NOT_SIGN_IN';
export const MAIN_LAYOUT_NOT_CHOOSE_CORP = 'MAIN_LAYOUT_NOT_CHOOSE_CORP';
export const MAIN_LAYOUT_NO_PERMISSION = 'MAIN_LAYOUT_NO_PERMISSION';
export const MAIN_LAYOUT_SET_PERMISSIONS = 'MAIN_LAYOUT_SET_PERMISSIONS';